/**
 * Creates a new object by omitting the specified keys from the original object.
 * @param obj The original object.
 * @param keys The keys to omit.
 * @returns A new object with the specified keys removed.
 */
export function omit<T extends object, K extends keyof T>(obj: T, ...keys: K[]): Omit<T, K> {
  const newObj = { ...obj };

  for (const key of keys) {
    delete (newObj as T)[key];
  }

  return newObj as Omit<T, K>;
}
